"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import { Drawer } from "antd";
import logo from "@/assets/images/logos/AlfaMall-Logo 90x90 px-01.png";
import {
  APP_DOWNLOAD_SHEET_EVENT,
  APP_NAME,
  copyStoreLink,
  getStoreName,
} from "./getOurAppConfig";
import "./GetOurApp.scss";

const COPIED_RESET_MS = 2500;

export default function GetOurAppDownloadSheet() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [storeName, setStoreName] = useState("Play Store");

  useEffect(() => {
    const show = () => {
      setStoreName(getStoreName());
      setCopied(false);
      setOpen(true);
    };

    window.addEventListener(APP_DOWNLOAD_SHEET_EVENT, show);
    return () => window.removeEventListener(APP_DOWNLOAD_SHEET_EVENT, show);
  }, []);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), COPIED_RESET_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = async () => {
    setCopied(await copyStoreLink());
  };

  return (
    <Drawer
      placement="bottom"
      open={open}
      closable={false}
      maskClosable
      height="auto"
      rootClassName="get-our-app-drawer"
      onClose={() => setOpen(false)}
    >
      <div className="get-our-app-row">
        <div className="get-our-app-brand">
          <Image src={logo} alt="AlfaMall" width={48} height={48} />
          <span>Get the {APP_NAME}</span>
        </div>
      </div>

      <ol className="get-our-app-steps">
        <li>
          Open the <strong>{storeName}</strong> on your phone
        </li>
        <li>
          Search for <strong>AlfaMall by Bank Alfalah</strong>
        </li>
        <li>
          Tap <strong>Install</strong>
        </li>
      </ol>

      <button type="button" className="get-our-app-copy" onClick={handleCopy}>
        {copied ? "Link copied ✓" : `Copy ${storeName} link`}
      </button>
      <p className="get-our-app-copy-hint">
        Or paste the copied link in Chrome to open the app page.
      </p>

      <button
        type="button"
        className="get-our-app-continue"
        onClick={() => setOpen(false)}
      >
        Continue shopping here
        <span aria-hidden="true">›</span>
      </button>
    </Drawer>
  );
}
